import { render, staticRenderFns } from "./UrunSabitKurItem.vue?vue&type=template&id=5ebf9f44&scoped=true"
import script from "./UrunSabitKurItem.vue?vue&type=script&lang=js"
export * from "./UrunSabitKurItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf9f44",
  null
  
)

export default component.exports